import { createBrowserHistory, createMemoryHistory, History, MemoryHistory } from 'history';

export const history: History = createBrowserHistory();

export const memoryHistory = (initialEntries?: string[]): MemoryHistory =>
  createMemoryHistory({ initialEntries });
